import React from 'react';
import { Line } from 'react-chartjs-2';

import 'chartjs-plugin-zoom';

export default class FinancialChart extends React.Component {
	constructor(props) {
        super(props);
		
        this.basicDataSet = {
            label: 'My First dataset',
			fill: false,
			snapGaps: true,
			lineTension: 0.1,
            backgroundColor: 'rgba(55,153,221,0.4)',
            borderColor: 'rgba(55,153,221,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointRadius: 0,
            pointBorderColor: 'rgba(0,0,0)',
            pointBackgroundColor: '#ffffff',
            pointBorderWidth: 0,
            pointHoverRadius: 0,
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderWidth: 2,
            // pointRadius: 1,
            pointHitRadius: 10,
			data: [],
			isYaxesPercentage: true,
          }
    
        this.basicOptions = {
            layout: {
                padding: {
                    left: 40,
                    right: 280,
                    top: 100,
                    bottom: 40
                }
            },
            legend: {
                display: false
            },
			maintainAspectRatio: false,
			scales: {
				xAxes: [{
					type: 'time',
					time: {
						unit: 'day'
					},
					ticks: {
                        padding: 10,
						autoSkip: true,
						autoSkipPadding: 10,
					}
				}],
				yAxes: [{
					id: 'main-y-axis',
                    type: 'linear',
                    ticks: {
                        padding: 10,
                        callback: function(value, index, values) {
							let percentage = value * 100;
							percentage = percentage.toFixed(2);
                            return percentage + "%";
                        }
                    }
					
				}]
			},
            tooltips: {
				enabled: props.useToolTips,
				bodyAlign: 'right',
				rtl: true,
				xPadding: 16,
				yPadding: 16,
				titleMarginBottom: 12,
				bodyMarginBottom: 12,
				bodyFontSize: 18,
				footerMarginTop: 12,
				footerFontSize: 12,
				displayColors: true,
                callbacks: {
					title: ( tooltipItem, data ) => {
						// const shortDate = tooltipItem[0].label.slice( 0, tooltipItem[0].label.length - 13 );
						return; // to present the date change this to: "shortDate"
					},
					
					afterTitle: ( tooltipItem, data ) => {
						const toolTip = tooltipItem[ 0 ];

						return data.datasets[ toolTip.datasetIndex ].label;

					},
					
					footer: ( tooltipItem, data ) => {
						const toolTip = tooltipItem[ 0 ];

						let value = data.datasets[ toolTip.datasetIndex ].originalValues[ toolTip.index ];

						if( !data.isYaxesPercentage ) {
							value *= 100;
							value = value.toFixed(2) + "%";
						}

						return "(" + value + ")";

                    },
                    
                    label: ( tooltipItem, data ) => {

						let value = tooltipItem.value;
						
						if( data.isYaxesPercentage ) {
							value = parseFloat( tooltipItem.value ) * 100;
							value = value.toFixed(2) + "%";
						}

                        return value;
                    }

				},				
			},
			plugins: {
				zoom: {
					pan: {
						enabled: true,
			
						mode: 'x',
			
						rangeMin: {
							x: null,
							y: null
						},
						rangeMax: {
							x: null,
							y: null
						},
			
						speed: 20,
			
						threshold: 1,
			
						// Function called while the user is panning
						// onPan: function({chart}) { console.log(`I'm panning!!!`); },
						// Function called once panning is completed
						// onPanComplete: function({chart}) { console.log(`I was panned!!!`); }
					},
			
					zoom: {
						
						enabled: true,
						drag: false,
						mode: 'x',
						rangeMin: {
							x: null,
							y: null
						},
						rangeMax: {
							x: null,
							y: null
						},
			
						speed: 0.1,
			
						sensitivity: 3,
			
						// Function called while the user is zooming
						// onZoom: function({chart}) { console.log(`I'm zooming!!!`); },
						// Function called once zooming is completed
						// onZoomComplete: function({chart}) { console.log(`I was zoomed!!!`); }
					}
				}
			}
		}
		
	}

    render() {

		const curDataStr = JSON.stringify(this.props.data)

		if(curDataStr !== this.lastDataStr) {
			const {
                measures,
                measuresToShow,
                colors,
				coronaData,
				period,
            } = this.props.data	
            
			this.lastDataStr = 	curDataStr	
			
			const graphData = {
				labels: [],
				datasets: [],
				hebrewLegend: coronaData.hebrew_legend,
			}

			this.userOptions = Object.assign( {}, this.basicOptions );
			
			let measuresCount = 0;
			measuresToShow.forEach(element => { if( element ) measuresCount ++ });
			graphData.isYaxesPercentage = measuresCount > 1;

			this.userOptions.scales.yAxes[0].ticks.callback = 
				function(value, index, values) {
					let percentage = value * 100;
					percentage = percentage.toFixed(2);

					return measuresCount === 1 ? value : percentage + "%";
				}
			

			if(this.lastPeriod !== period ) {
				this.redraw = true;
				this.lastPeriod = period;
			} else { this.redraw = false; }

			const startingDate = new Date( period );


			measures.forEach((measure, i) => {

				if( !measuresToShow[ i ] ) { return; }

				const measureData = coronaData.financial_data[ measure.key ];


				const dataSet = Object.assign( {}, this.basicDataSet );
				dataSet.label = measure.title;
				
				if( measureData === undefined ) { 
					
					console.log( measure.title + " does not exist" );
					graphData.datasets.push(dataSet);
					return; 
				}


				const lineColor = colors[i];
				dataSet.borderColor = lineColor;
				dataSet.pointBackgroundColor = lineColor;

				const graphNumbers = [];
				const originalValues  = [];

				let periodData = undefined;			
				const periodStartingDate = new Date( period );
			
				let earliest = new Date();
				measureData.forEach( item => {
					const date = new Date( item.d );
					if( date < earliest && date >= periodStartingDate ) {
						periodData = item;
						earliest = date;
					}
				});

				for( let i=0; i<measureData.length; i++ ) {
				
                    const initData = periodData ? periodData : measureData[ 0 ];
					const currData = measureData[ i ];
					
					const date = new Date( currData.d );

					if( date < startingDate ) continue;
										
					const percentage = ( currData.v - initData.v ) / initData.v;
                    const value = measuresCount > 1 ? percentage : currData.v;
					
					if(currData === undefined) return;
					
					
					graphNumbers.push( {t: date, y: value } );
					originalValues.push( measuresCount > 1 ? currData.v : percentage );
                
                }
				
				dataSet.data = graphNumbers;
				dataSet.originalValues = originalValues;

				graphData.datasets.push(dataSet)
			})

			if( graphData.datasets.length > 0 ) {

				this.userOptions.plugins.zoom.pan.rangeMin.x = startingDate;
				this.userOptions.plugins.zoom.pan.rangeMax.x = Date.now();
	
				this.userOptions.plugins.zoom.zoom.rangeMin.x = startingDate;
				this.userOptions.plugins.zoom.zoom.rangeMax.x = Date.now();
			}


			this.curGraphData = graphData
		}

		return <Line key={"financial-graph"} data={this.curGraphData} redraw={this.redraw} options={this.userOptions}/>
        
    }
}